module.exports = __webpack_public_path__ + "img/hong meiling_sc1.5f43c705.png";